import { Stack } from "@mui/material";
import { Message } from "./Message/Message";
import { useCopilotStore } from "../../store/copilot/CopilotStore";
import { useEffect, useRef } from "react";
import { MessageType } from "../../apis/copilot/types";

export const Messages = () => {
  const { messages, isMinimized } = useCopilotStore();
  const messagesEndRef = useRef<HTMLDivElement>(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    if (!isMinimized) scrollToBottom();
  }, [isMinimized, messages]);

  const renderableMessages = messages
    .filter((message) => message.type !== MessageType.TOOL_MESSAGE)
    .filter((message) => message.payload.content !== "I inserted it.");

  return (
    <Stack
      flexDirection="column"
      flex={1}
      overflow="auto"
      p={2}
      gap={3}
      justifyContent="flex-start"
    >
      {renderableMessages.map((props, index) => {
        const showRetry =
          index === renderableMessages.length - 1 &&
          (props.type === MessageType.AI_MESSAGE ||
            props.type === MessageType.AI_SELECT_MESSAGE ||
            props.type === MessageType.AI_CHUNK);

        return <Message key={props.id} {...props} showRetry={showRetry} />;
      })}
      <div ref={messagesEndRef} />
    </Stack>
  );
};
